import React from "react";
import { Pagination, ReferenceManyField, useTranslate } from "react-admin";
import { DEFAULT_PER_PAGE, DEFAULT_ROWS_PER_PAGE_OPTIONS, translatePaginationOptions } from "./pagination";

export const AppReferenceManyField = (props) => {
	const {
		perPage = DEFAULT_PER_PAGE,
		rowsPerPageOptions = DEFAULT_ROWS_PER_PAGE_OPTIONS,
		pagination: paginationProp,
		...rest
	} = props;

	const translate = useTranslate();

	const pagination =
		paginationProp ??
		<Pagination rowsPerPageOptions={translatePaginationOptions(rowsPerPageOptions, translate)} />;

	return (
		<ReferenceManyField
			perPage={perPage}
			pagination={pagination}
			{...rest}
		/>
	);
};
